export const MANUAL_DELAYED_PUBLICATION_SCREEN = 'item_view_manual_delayed_publication'
export const MANUAL_DELAYED_PUBLICATION_MODAL_SCREEN = 'item_view_manual_delayed_publication_modal'
